module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_wwpt-b3172faeac9b7e602c6de1b3a314000c.svg";